// These models were pulled out form the enterprise code generation to prevent circular dependencies between the api-service lib and code gen libs.
export enum ResponseCode {
    None = 0,
    Success = 200,
    Redirect = 302,
    InvalidRequest = 400,
    Unauthorized = 401,
    Forbidden = 403,
    NotFound = 404,
    Conflict = 409,
    Error = 500
}

export class Request {}
export class Response {
    public code: ResponseCode | null = null;
    public message: string | null = null;
    constructor(obj?: { code?: ResponseCode; message?: string }) {
        if (obj != null) {
            this.code = typeof obj.code === 'undefined' ? this.code : obj.code;
            this.message = typeof obj.message === 'undefined' ? this.message : obj.message;
        }
    }
}

export class MessageRequest extends Request {
    public messageType: string | null = null;
    public message: string | null = null;
    constructor(obj?: { messageType?: string; message?: string }) {
        super();
        if (obj != null) {
            this.messageType =
                typeof obj.messageType === 'undefined' ? this.messageType : obj.messageType;
            this.message = typeof obj.message === 'undefined' ? this.message : obj.message;
        }
    }
}

export enum SortDirectionEnterprise {
    Desc = 1,
    Asc = -1
}

export class FilterRequest extends Request {
    public skip = 0;
    public take = 25;
    public sortColumn: string = null;
    public sortDirection: SortDirectionEnterprise = null;
    constructor(obj?: {
        skip?: number;
        take?: number;
        sortColumn?: string;
        sortDirection?: SortDirectionEnterprise;
    }) {
        super();
        if (obj != null) {
            this.skip = typeof obj.skip === 'undefined' ? this.skip : obj.skip;
            this.take = typeof obj.take === 'undefined' ? this.take : obj.take;
            this.sortColumn =
                typeof obj.sortColumn === 'undefined' ? this.sortColumn : obj.sortColumn;
            this.sortDirection =
                typeof obj.sortDirection === 'undefined' ? this.sortDirection : obj.sortDirection;
        }
    }
}

export class BaseListResponse extends Response {
    public totalCount: number = null;
    public skip: number = null;
    public take: number = null;
    public sortColumn: string = null;
    public sortDirection: SortDirectionEnterprise = null;
    constructor(obj?: {
        code?: ResponseCode;
        message?: string;
        totalCount?: number;
        skip?: number;
        take?: number;
        sortColumn?: string;
        sortDirection?: SortDirectionEnterprise;
    }) {
        super(obj);
        if (obj != null) {
            this.totalCount =
                typeof obj.totalCount === 'undefined' ? this.totalCount : obj.totalCount;
            this.skip = typeof obj.skip === 'undefined' ? this.skip : obj.skip;
            this.take = typeof obj.take === 'undefined' ? this.take : obj.take;
            this.sortColumn =
                typeof obj.sortColumn === 'undefined' ? this.sortColumn : obj.sortColumn;
            this.sortDirection =
                typeof obj.sortDirection === 'undefined' ? this.sortDirection : obj.sortDirection;
        }
    }
}

export class ListResponse<T> extends BaseListResponse {
    public rows: T[] = null;
    constructor(obj?: {
        code?: ResponseCode;
        message?: string;
        totalCount?: number;
        skip?: number;
        take?: number;
        sortColumn?: string;
        sortDirection?: SortDirectionEnterprise;
        rows?: T[];
    }) {
        super(obj);
        if (obj != null) {
            this.rows = typeof obj.rows === 'undefined' ? this.rows : obj.rows;
        }
    }
}

export interface GraphQLResponse<T> {
    data: T;
}
